import { render, staticRenderFns } from "./dataItem.vue?vue&type=template&id=844a0742"
import script from "./dataItem.vue?vue&type=script&lang=js"
export * from "./dataItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('844a0742')) {
      api.createRecord('844a0742', component.options)
    } else {
      api.reload('844a0742', component.options)
    }
    module.hot.accept("./dataItem.vue?vue&type=template&id=844a0742", function () {
      api.rerender('844a0742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dataQueryManage/dataItem.vue"
export default component.exports